import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail } from 'lucide-react';
import apiClient from '../lib/apiClient';
import storage from '../lib/storage';
import './AdminPanel.css';

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await apiClient.request('/admin/login', {
        method: 'POST',
        auth: false,
        body: JSON.stringify({ email, password })
      });

      if (!data?.success) {
        setError(data.message || 'Falha ao autenticar como admin');
        return;
      }

      storage.set('adminAuthToken', data.token);
      storage.set('adminEmail', data.admin?.email || email);
      navigate('/admin', { replace: true });
    } catch (requestError) {
      setError('Erro de conexão com o servidor admin');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card card">
        <h1>Painel Admin</h1>
        <p>Acesso restrito ao proprietário do Marketing PRO.</p>

        {error && <div className="admin-error">{error}</div>}

        <form onSubmit={handleSubmit} className="admin-form">
          <div className="input-group">
            <label htmlFor="admin-email"><Mail size={14} /> E-mail</label>
            <input
              id="admin-email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="input-group">
            <label htmlFor="admin-password"><Lock size={14} /> Senha</label>
            <input
              id="admin-password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
              disabled={loading}
            />
          </div>

          <button className="btn btn-outline btn-full" type="submit" disabled={loading}>
            {loading ? 'Validando...' : 'Entrar no painel'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
